import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  ScriptData,
  ScriptErrorResponse,
  ScriptExecutionResponse,
} from '../code';
import { ScriptWorkerService } from '../services';
import { State } from '../services/work.state';
import { EnvironmentVariables } from '@adreno-common';

export const executeEntry = (
  scriptWorker: ScriptWorkerService,
  environment: EnvironmentVariables
) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.navToQ && state.system?.navToQ != '?') {
        const { system, master, action, answers, variables, inputs } = {
          ...currentState,
          ...state,
        };
        return scriptWorker
          .send$({
            type: 'entry',
            question: state.system.navToQ,
            app: {
              system: {
                ...state.system,
                ...{
                  displayQ: state.system?.navToQ,
                  navBack: undefined,
                  navToQ: undefined,
                  qHistory: [
                    state.system?.navToQ!,
                    ...(state.system?.qHistory || []),
                  ],
                  qPath: [
                    state.system?.navToQ!,
                    ...(state.system?.qPath || []),
                  ],
                },
              },
              master,
              action,
              answers,
              variables,
              inputs,
              apiPath: environment.apiPath,
            } as ScriptData,
          })
          .pipe(
            map((res) => res as ScriptExecutionResponse | ScriptErrorResponse),
            map((execResp) => {
              //do not reset system.navToQ - displayScript does that...
              if (execResp.type === 'error') {
                return {
                  ...state,
                  qNo: execResp.question,
                  ...execResp.data,
                  system: {
                    ...state.system,
                    error: execResp.error.message,
                    navToQ: undefined,
                  },
                };
              }
              return {
                ...state,
                ...execResp.app,
              };
            }),
            map((state) => [state, currentState] as [Partial<State>, State])
          );
      } else {
        return of([state, currentState] as [Partial<State>, State]);
      }
    })
  );
